// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-2VXKU","lds-ring":"index-lds-ring-U02LH"};